"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ResyncFoldersActionTypes = require("../../../actionTypes/vektorio/resyncFolders");
const status_1 = require("../../../status");
exports.initialState = {
    status: status_1.RequestStatusFactory.fetch.standby(),
    error: null
};
const statusLens = monocle.Lens.fromProp('status');
const errorLens = monocle.Lens.fromProp('error');
const methods = {};
exports.methods = methods;
methods[ResyncFoldersActionTypes.REQUEST] = (state) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.busy()), errorLens.set(null))(state);
methods[ResyncFoldersActionTypes.SUCCESS] = (state) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.success()), errorLens.set(null))(state);
methods[ResyncFoldersActionTypes.FAILURE] = (state, { error }) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.failure()), errorLens.set(error))(state);
//# sourceMappingURL=index.js.map